<template>
  <transition name="fade" @before-leave="beforeLeaveHandler">
    <div class="article-container" @click.stop="$emit('on-close')">
      <div class="main">
        <div class="return-btn">
          <!-- <img src="../assets/images/icon-return-popup.png" class="return" /> -->
          <!-- <Icon type="md-arrow-round-back" class="return" />
          返回 -->
        </div>
        <div class="content-container" @click.prevent.stop="showEmoji">
          <div class="img-video">
            <div class="swiper-container" v-if="detail.type == '1'">
              <swiper :options="swiperOptions" ref="mySwiper">
                <!-- Slides -->
                <swiper-slide
                  v-for="(item, index) in detail.image_list"
                  :key="index"
                >
                  <img :src="item" class="swiper-img" />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
              <!-- Custom Buttons -->
              <button class="custom-prev-btn">
                <img
                  src="@/assets/images/icon-prev-circle.png"
                  style="width: 32px; height: 32px"
                />
              </button>
              <button class="custom-next-btn">
                <img
                  src="@/assets/images/icon-next-circle.png"
                  style="width: 32px; height: 32px"
                />
              </button>
            </div>
            <div
              v-else
              style="width: 100%; height: 100%"
              @contextmenu.prevent
              @copy.prevent
              @cut.prevent
            >
              <video
                :src="detail.video"
                @contextmenu.prevent
                @copy.prevent
                autoplay="true"
                muted="true"
                loop="true"
                style="width: 100%; height: 100%; background: #000000"
                controls
              ></video>
            </div>
          </div>
          <div class="desc-container">
            <!-- 右侧顶部功能区 -->
            <div class="right-top">
              <div class="nick-avatar-box">
                <img @click.prevent.stop="onAvatarClick(detail.member.code || '')" :src="detail.member.avatar | default_avatar" class="avatar" />
                <div class="nick-box">
                  <div class="nick">
                    {{ detail.member.nickname || detail.member.username || "" }}
                  </div>
                  <div
                    class="job"
                    v-if="
                      detail.member && (detail.member.zone || detail.member.job)
                    "
                  >
                    {{
                      detail.member.zone
                        ? `${
                            detail.member.job
                              ? detail.member.zone + "|"
                              : detail.member.zone
                          }`
                        : ""
                    }}
                    {{ detail.member.job || "" }}
                  </div>
                </div>
              </div>
              <div class="btn-box">
                <div class="like-box" @click.prevent.stop="onPostsLike">
                  <img
                    :src="
                      detail.is_zan == 1
                        ? require('../assets/images/icon-liked-posts.png')
                        : require('../assets/images/icon-like-popup.png')
                    "
                    class="like-icon"
                  />
                  <div class="like-num">{{ detail.zan_count || 0 }}</div>
                </div>
                <div class="favorite-box" @click.prevent.stop="onPostsCollect">
                  <img
                    :src="
                      detail.is_collect == 1
                        ? require('../assets/images/icon-favorited-posts.png')
                        : require('../assets/images/icon-favorite.png')
                    "
                    class="favorite-icon"
                  />
                  <div class="favorite-num">
                    {{ detail.collect_count || 0 }}
                  </div>
                </div>
                <Poptip
                  placement="bottom"
                  trigger="hover"
                >
                  <template #content>
                    <div class="pop-share">
                      <img
                        src="../assets/images/icon-link-share.png"
                        class="link-icon"
                      />复制分享链接
                    </div>
                  </template>
                  <div @click.prevent.stop="onCopyLink"
                    class="share-btn"
                  >
                    <img
                      src="../assets/images/icon-share-square.png"
                      class="share-icon"
                    />
                  </div>
                </Poptip>
                <Button v-if="!is_login || (userInfo.code != detail.member.code)"
                  :class="[
                    detail.is_follow == 1 ? 'unfollow-btn' : 'follow-btn',
                  ]"
                  @click.prevent.stop="onFllowUser"
                  >{{ detail.is_follow == 1 ? "已关注" : "关注" }}</Button
                >
              </div>
            </div>
            <!-- 评论区|描述|标签 -->
            <div ref="contentBox" class="content-box">
              <div class="content-main">
                <!-- 标题 -->
                <div class="content-title">{{ detail.title }}</div>
                <!-- 时间|浏览量 -->
                <div class="time-view-box">
                  <div class="time-view-container">
                    <div class="time">编辑于：{{ detail.create_time }}</div>
                    <div class="view-box">
                      <img
                        src="../assets/images/icon-view-popup.png"
                        class="view-icon"
                      />
                      <span>{{ detail.view_times }}浏览</span>
                    </div>
                  </div>
                  <div class="more-box">
                    <img @click.stop="is_report_post_show=true" class="more-icon" src="../assets/images/icon-more-comment.png" />
                    <div v-if="is_report_post_show" class="report-post-btn" @click.stop="onReportClick(1,uuid)">举报</div>
                  </div>
                </div>
                <!-- 内容 -->
                <div :class="['desc-content',{'content-border':!detail.product || !detail.product.uuid}]" v-html="detail.content"></div>
                <!-- 关联商品 -->
                <div v-if="detail.product && detail.product.uuid" class="product-box" @click="onProductDetail(detail.product)">
                  <div class="product-container">
                    <img :src="detail.product.image" alt="" class="product-cover" />
                    <div class="product-info">
                      <div class="product-name">{{ detail.product.name }}</div>
                      <div class="price-tag-box">
                        <div class="price">¥{{ detail.product.sale_price }}</div>
                        <div v-if="detail.product.is_7day_return === 1" class="tag">七天无理由</div>
                        <div class="tag">已售{{ detail.product.sales }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 标签 -->
                <!-- <div class="tags-box">
                                    <div class="tags-item" v-for="item in 5" :key="item">#标签{{ item }}</div>
                                </div> -->
                <!-- 评论区 -->
                <div class="comment-box">
                  <div class="comment-title">
                    评论
                    <span class="comment-count"
                      >(共{{ detail.comment_count || 0 }}条)</span
                    >
                  </div>
                  <div class="comment-main">
                    <!-- 评论主体 -->
                    <template v-if="comment_list.length > 0">

                      <div
                        class="comment-item-box"
                        v-for="(item, index) in comment_list"
                        :key="index"
                      >
                        <img
                          :src="item.frommember.avatar | default_avatar"
                          class="comment-avatar" @click.prevent.stop="onAvatarClick(item.frommember.code || '')"
                        />
                        <div style="flex: 1; overflow-x: hidden">
                          <div class="comment-nick-box">
                            <div class="comment-nick">
                              <template>
                                {{
                                  item.frommember.nickname ||
                                  item.frommember.username
                                }}<span
                                  v-if="
                                    item.frommember.username &&
                                    item.frommember.username == detail.member.username
                                  "
                                  class="comment-nick-tag"
                                  >作者</span
                                >
                              </template>
                            </div>
                            <!-- v-if="item.from_user_id === userInfo.id"  -->
                            <div @click.prevent.stop="onMoreClick(index)" class="nick-more-menu">
                              <img src="../assets/images/icon-more-comment.png" />
                              <div v-if="item.show_report" class="report-btn" @click="onReportClick(2,item.uuid)">举报评论</div>
                              <div v-if="item.from_user_id === userInfo.id && item.show_delete_comment" @mouseleave="onMoreClick(index)" @click.prevent.stop="onDeleteComment(item,index)" class="delete-btn">删除评论</div>
                            </div>
                          </div>
                          <div class="comment-content">{{ item.content }}</div>
                          <div class="comment-time">{{ item.create_time|duration_text }}</div>
                          <div class="comment-like-count">
                            <div
                              class="comment-like-count-item-left"
                              @click.prevent.stop="onCommentLike(item.uuid)"
                            >
                              <img
                                :src="
                                  item.is_zan == 1
                                    ? require('../assets/images/icon-liked-posts.png')
                                    : require('../assets/images/icon-like-popup.png')
                                "
                                class="like-count-icon"
                              />
                              <span>{{ item.zan_count }}</span>
                            </div>
                            <div
                              class="comment-like-count-item-right"
                              @click.prevent.stop="onReplyClick(item)"
                            >
                              <img
                                src="../assets/images/icon-reply-popup.png"
                                class="like-count-icon"
                              />
                              <span>{{ item.reply_count }}</span>
                            </div>
                          </div>
                          <!-- 评论回复 -->
                          <template v-if="item.children.length > 0">
                            <div
                              class="comment-child-box"
                              v-for="(child, i) in (item.showAllReplies ? item.children : [item.children[0]])"
                              :key="i"
                            >
                              <img
                                :src="child.frommember.avatar | default_avatar"
                                class="comment-avatar" @click="onAvatarClick(child.frommember.code || '')"
                              />
                              <div class="nick-box">
                                <div class="nick-container">
                                  <div class="comment-nick-box">
                                    <div style="display:flex;">
                                      <div class="comment-nick">
                                        {{
                                          child.frommember.nickname ||
                                          child.frommember.username
                                        }}<span
                                          v-if="
                                            child.frommember.username ==
                                            detail.member.username
                                          "
                                          class="comment-nick-tag"
                                          >作者</span
                                        >
                                      </div>
                                      <div
                                        v-if="
                                          child.tomember.username !=
                                          item.frommember.username
                                        "
                                        style="
                                          flex: 1;
                                          color: #858585;
                                          font-size: 16px;
                                          white-space: nowrap;
                                        "
                                      >
                                        回复了<span style="padding-left: 10px">{{
                                          child.tomember.nickname ||
                                          child.tomember.username
                                        }}</span>
                                        <span
                                          v-if="
                                            child.tomember.username ==
                                            detail.member.username
                                          "
                                          class="comment-nick-tag"
                                          >作者</span
                                        >
                                      </div>
                                    </div>
                                    <div @click.prevent.stop="onMoreClick(index,i)" class="nick-more-menu">
                                      <img src="../assets/images/icon-more-comment.png" />
                                      <!--  v-if="child.from_user_id === userInfo.id" -->
                                      <div v-if="child.from_user_id === userInfo.id && child.show_delete_comment" @mouseleave="onMoreClick(index,i)" @click.prevent.stop="onDeleteComment(child,i,true)" class="delete-btn">删除评论</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="comment-content">
                                  {{ child.content }}
                                </div>
                                <div class="comment-time">
                                  {{ child.create_time|duration_text }}
                                </div>
                                <div class="comment-like-count-box">
                                  <div
                                    class="comment-like-count-item-left"
                                    @click.prevent.stop="onCommentLike(child.uuid)"
                                  >
                                    <img
                                      :src="
                                        child.is_zan
                                          ? require('../assets/images/icon-liked-posts.png')
                                          : require('../assets/images/icon-like-popup.png')
                                      "
                                      class="comment-like-count-icon"
                                    />
                                    <span>{{ child.zan_count }}</span>
                                  </div>
                                  <div
                                    class="comment-like-count-item-right"
                                    @click.prevent.stop="onReplyClick(child)"
                                  >
                                    <img
                                      src="../assets/images/icon-reply-popup.png"
                                      class="comment-like-count-icon"
                                    />
                                    <!-- <span>5</span> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="item.children.length>1" @click.prevent.stop="toggleReplies(index)" class="more-comment">{{ item.showAllReplies ? '收起' : `展开${item.children.length - 1}条评论` }}</div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div ref="replyBox" v-show="is_replying" class="reply-box">
              <div class="reply-to">回复 {{reply_comment.reply_name}}</div>
              <div class="reply-content">{{reply_comment.reply_content}}</div>
            </div>
            <div class="comment-form">
              <div class="comment-input-box" @click.prevent.stop="onInputClick">
                <div v-if="!is_login" class="un-login">请先登录</div>
                <input v-else
                  class="comment-input"
                  placeholder="说点什么吧"
                  v-model="comment_content" @click.prevent.stop="showEmoji"
                />
              </div>
              <div class="function-box">
                <!-- <img src="" class="icon-emoji" /> -->
                <!-- 引入EMOJI表情库 -->
                <emoji-picker @emoji="append">
                  <button id="emojiBtn" ref="emojiBtn"
                    class="icon-emoji"
                    slot="emoji-invoker"
                    slot-scope="{ events: { click: clickEvent } }"
                    @click.stop="($event)=>{
                      clickEvent($event);
                      show_emoji = !show_emoji;
                    }"
                  ></button>
                  <div
                    slot="emoji-picker"
                    slot-scope="{ emojis, insert, display }"
                  >
                    <div
                      class="emoji-picker"
                      :style="{ top: (display.y) + 'px', left: (display.x) + 'px' }"
                    >
                      <!-- <div class="emoji-picker__search">
                        <input type="text" v-model="search" v-focus />
                      </div> -->
                      <div>
                        <div
                          v-for="(emojiGroup, category) in emojis"
                          :key="category"
                        >
                          <h5>{{ category }}</h5>
                          <div class="emojis">
                            <span
                              v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click.stop="insert(emoji)"
                              :title="emojiName"
                              >{{ emoji }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </emoji-picker>
                <div class="form-btn-box">
                  <Button v-if="is_replying" class="cancel-btn" @click.prevent.stop="is_replying=false">取消</Button>
                  <Button class="submit-btn" @click.prevent.stop="onReplyPosts">发送</Button>
                </div>
              </div>
            </div>
          </div>
          <login-pop v-if="show_login" @close-login="closeLoginpop"></login-pop>
        </div>
        <div style="margin-top: 30px">
          <Icon
            type="md-close"
            size="19"
            @click.prevent.stop="$emit('on-close')"
            style="cursor: pointer;color:white;background:rgba(0,0,0,0.5);border-radius:50%;padding:13px;"
          />
        </div>
      </div>
      <popup @click.stop :width="report_step == 3 ? '560px' :'440px'" :show.sync="is_show_report" @close="closeReport">
        <div class="popup" @click.stop>
          <div v-if="[1,2].includes(report_step)" class="title">举报帖子</div>
          <div v-if="report_step == 1" class="report-list">
            <div class="report-list-item" v-for="(item,index) in setting.report" :key="index" @click.stop="report_selected = item">
              <div class="report-list-item-selection">
                <div :class="['label',{'label-active':item.title === report_selected.title}]">{{item.title}}</div>
                <div :class="['value',{'value-active':item.title === report_selected.title}]">
                  <span v-if="item.title === report_selected.title">✔</span>
                </div>
              </div>
              <div v-if="item.title === report_selected.title" class="report-list-item-description">
                {{item.description}}
              </div>
            </div>
          </div>
          <div v-if="report_step == 2" class="report-confirm">
            <img src="@/assets/images/icon-attention.png" alt="" class="report-attention">
            <div class="report-reason">举报理由: {{ report_selected.title }}</div>
            <div class="report-reason-description">{{ report_selected.description }}</div>
            <div class="report-form">
              <div class="report-label-container">
                <div class="report-label">举报描述</div>
                <div class="report-content-count">{{report_content.length || '0'}}/200</div>
              </div>
              <div class="report-description">
                <textarea
                  v-model="report_content"
                  class="report-textarea"
                  placeholder="请如实填写被骗过程、受损金额,并提供对方诱导你转账的聊天证据、转账记录等。如已产生钱财损失,建议向公安机关报案,衣创社区将全力配合司法机关"
                  maxlength="200"
                ></textarea>
              </div>
              <div class="report-label-container">
                <div class="report-label">图片证据</div>
                <div class="report-content-count">{{image_list.length}}/4</div>
              </div>
              <div class="image-list">
                <div class="image-item" v-for="(item,index) in image_list" :key="index">
                  <img :src="item|default_img" alt="" v-viewer />
                  <img @click.stop="onDeleteImg(index)" src="@/assets/images/icon-close-circle-transparent.png" alt="" class="remove-ico">
                </div>
                <Upload v-if="image_list.length < 4"
                  type="drag"
                  :action="upload_url"
                  :data="{ dir: 'template' }"
                  multiple
                  :before-upload="onBeforeUpload"
                  :show-upload-list="false"
                >
                  <div class="upload-btn">
                    <img src="@/assets/images/icon-upload.png" alt="" class="upload-ico">
                    <div class="btn-text">上传图片</div>
                  </div>
                </Upload>
              </div>
            </div>
          </div>          
          <div v-if="[1,2].includes(report_step)" class="pop-bottom">
            <Button @click.stop="onReportSubmit">{{ report_step == 1 ? '下一步' : '提交' }}</Button>
          </div>
          <div v-if="report_step == 3" class="report-result">
            <img src="@/assets/images/icon-success-green.png" alt="" class="success-icon">
            <div class="success-title">举报已提交</div>
            <div class="success-tips">感谢您的反馈!我们已收到您的举报,我们将尽快进行审核处理.</div>
            <div class="report-introduction">
              <div class="intro-container">
                <div class="intro-title">
                  <img src="@/assets/images/icon-warning-blue.png" />举报处理说明
                </div>
                <p>◆   我们会根据社区规范对举报内容进行审核</p>
                <p>◆   如举报属实，我们将对违规内容采取相应措施</p>
                <p>◆   处理结果将通过系统通知告知您</p>
              </div>
            </div>
            <div class="report-introduction-btns">
              <Button @click.stop="closeReport">返回帖子</Button>
              <Button @click="$emit('on-close')">浏览其他内容</Button>
            </div>
          </div>
        </div>
      </popup>
    </div>
  </transition>
</template>
<script>
import {
  CommentDelete,
  CommentLike,
  FollowUser,
  GetMatchPostDetail,
  GetMatchPostsCommentList,
  GetPostsByUUID,
  GetPostsCommentList,
  MatchPostsCollect,
  MatchPostsCommentDelete,
  MatchPostsCommentLike,
  MatchPostsLike,
  MatchReplyPosts,
  PostsCollect,
  PostsLike,
  ReplyPosts, submitReport
} from "@/api/social";
import LoginPop from '@/components/LoginPop';
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { EmojiPicker } from "vue-emoji-picker";
import { mapState } from 'vuex';

export default {
  name: "ArticleDetail",
  components: {
    swiper,
    swiperSlide,
    EmojiPicker,LoginPop,Popup
  },
  props: {
    uuid: {
      type: [String,Number],
      default: () => {
        return "";
      },
    },
    postType:{
      type: [String,Number],
      default: () => {
        return 1;
      },

    }
  },

  beforeDestroy() {
    document.body.style.overflow = '';
  document.body.style.height = '';
  document.body.style.width = '';
  },
  created() {},
  async mounted() {
    // 锁定页面滚动
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    console.log('this.user_info',this.userInfo);
    await Promise.all([
      this.onGetPosts(),
      this.onGetPostsCommentList(),      
    ])
    // await this.onGetPosts();
    // await this.onGetPostsCommentList();
  },
  computed:{
    ...mapState(['userInfo','setting']),
    is_login(){
      return this.$store.state.is_login;
    }
  },
  watch: {
    is_replying(news,olds){
      // if(news){
        this.heightCpt();
      // }
      if(!news){
        this.reply_comment = {};
        this.select_quote_uuid = '';
        this.select_post_uuid = '';
      }
    }
  },
  data() {
    return {
      detail: {
        type: "1",
        image_list: [],
        member: {},
      },
      is_share_click: false,
      swiperOptions: {
        // 核心配置
        slidesPerView: 1, // 每页显示 1 张幻灯片
        centeredSlides: true, // 当前幻灯片居中显示
        spaceBetween: 20, // 幻灯片间距
        loop: true, // 启用循环模式
        loopedSlides: 0,
        grabCursor: true, // 拖动时显示抓手光标
        autoplay: {
          delay: 3000, // 3秒切换
          disableOnInteraction: false, // 手动滑动后继续自动播放
        },
        // 导航按钮配置
        navigation: {
          prevEl: ".custom-prev-btn",
          nextEl: ".custom-next-btn",
        },
        pagination: {
          el: ".swiper-pagination", // 指定分页器容器选择器
          type: "bullets", // 类型：bullets（圆点）、fraction（分数）、progress（进度条）等
          clickable: true, // 允许点击分页器切换幻灯片
          bulletActiveClass: "my-swiper-pagination-active", // 自定义激活状态类名
        },
      },
      comment_list: [],
      comment_content: "",
      select_post_uuid: "",
      select_quote_uuid: "",
      reply_status: false,
      is_replying: false,
      org_height:'',
      reply_comment:{},
      show_delete_comment:false,
      show_login:false,
      show_emoji:false,
      is_show_report:false,
      report_selected:{},
      report_step:1,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      uploading: false,
      uploadQueue:[],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
      image_list:[],
      report_content:'',
      content_type:1,
      report_uuid:'',
      is_report_post_show:false
    };
  },
  methods: {
    onProductDetail(product){
      if(!product || !product.uuid){
        this.$layer.msg('商品不存在');
        return;
      }
      this.$router.push({name:'GoodsDetail',params:{uuid:product.uuid}})
    },
    onReportClick(content_type,report_uuid){
      this.content_type = content_type;
      this.report_uuid = report_uuid;
      this.is_show_report = true;
      if(content_type == 1){
        this.is_report_post_show = false;
      }
    },
    onDeleteImg(index){
      this.image_list.splice(index,1);
    },
    async processAllFiles() {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`Startting upload ${queue.length} files...`);

      for (const file of queue) {
          try {
          const url = await uploadFileToOSS(file, "template");
          console.log('url==>',url);
          // this.image_list.push({raw:url,raw_name:file.name});
          this.image_list.push(url);
          console.log('image_list',this.image_list);
          // console.log('this.image_list',this.image_list);
          } catch (err) {
          this.$layer.msg(`上传失败==>：${file.name}`);
          }
      }

    },
    onBeforeUpload(file) {
      console.log("file-before", file);
      this.uploading = true;
      // 将文件加入队列
      this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
          this.processAllFiles();
      }, this.debounceTime);
      return false;
    },
    async onReportSubmit(){
      if(this.report_step == 1){
        this.report_step = 2;
        return;
      }
      try{
        const {report_content,image_list,report_selected,content_type,report_uuid} = this;
        const {title,description}  = report_selected;
        const param = {}
        param.reason = title;
        param.reason_description = description;
        param.image_list = image_list;
        param.report_description = report_content;
        param.uuid = report_uuid;
        param.content_type = content_type;
        await submitReport(param);
        this.report_step = 3;
      }catch(e){
        console.log('err->submit',e);
        this.$layer.msg(e.msg);
      }
    },
    closeReport(){
      this.is_show_report = false;
    },
      closeLoginpop(){
				this.show_login = false;
			},
    async onDeleteComment(item,index,child=false){
      console.log('item',item);
      try{
        const {uuid} = this;
        const param = {};
        param.post_uuid = uuid;
        param.comment_uuid = item.uuid;
        if(this.postType == 1){
          await CommentDelete(param);
        }else{
          await MatchPostsCommentDelete(param);
        }
        this.$layer.msg('删除成功');
        this.onGetPostsCommentList();
      }catch(e){
        console.log('err-delete-comment',e);
      }
    },
    onMoreClick(index,child=null){
      if(child == null){
        console.log('child',child);
        const {show_delete_comment,show_report} = this.comment_list[index];
        this.$set(this.comment_list[index],'show_delete_comment',!show_delete_comment);
        this.$set(this.comment_list[index],'show_report',!show_report);
      }else{
        const {show_delete_comment,show_report} = this.comment_list[index].children[child];
        this.$set(this.comment_list[index].children[child],'show_delete_comment',!show_delete_comment);
        this.$set(this.comment_list[index].children[child],'show_report',!show_report);
      }
    },
    onInputClick(){
      if(!this.is_login){
        this.$layer.msg('请先登录');
        this.show_login = true;
        //this.$router.push({name:"Login"});
      }
    },
    heightCpt(){
      this.$nextTick(() => {
          const contentBox = this.$refs.contentBox.getBoundingClientRect();
          if (!contentBox) return;
          const replyBox = this.$refs.replyBox.getBoundingClientRect();
          if (this.is_replying && replyBox) {
            const newHeight = contentBox.height - replyBox.height;
            this.$refs.contentBox.style.height = `${newHeight.toFixed(2)}px`;
            // this.$refs.contentBox.style['max-height'] = `${newHeight.toFixed(2)}px`;
          } else {
            this.$refs.contentBox.style.height = this.org_height;
            this.$refs.contentBox.style['max-height'] = this.org_height;
          }
      });
    },
    onAvatarClick(code){
      const uri = `${window.location.origin}/userProfile/${code}`;
      console.log('uri',uri);
      window.open(uri,'_blank');
    },
    toggleReplies(index) {
      this.$set(this.comment_list[index], 'showAllReplies', !this.comment_list[index].showAllReplies);
    },
    showEmoji(){
      console.log('this.show_emoji',this.show_emoji);
      if(this.show_emoji){
        console.log('aaa',this.show_emoji);
        this.$nextTick(()=>{
          this.$refs.emojiBtn.click();
          // const btn = document.getElementById('emojiBtn')
          // console.log('btn===>',btn);
          // if(btn){
          //   btn.click();
          // }
        })
      }
    },
    clickEvent(e) {
      console.log("clickEvent", e);
      this.show_emoji = !this.show_emoji;
    },
    append(emoji) {
      console.log("emoji", emoji);
      this.comment_content += emoji;
    },
    async onCommentLike(uuid) {
      try {
        console.log("uuid", uuid);
        if(!this.is_login){
          this.$layer.msg('请先登录');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        if(this.postType == 1){
          await CommentLike({ uuid });
        }else{
          await MatchPostsCommentLike({uuid});
        }
        this.$layer.msg("操作成功");
        this.onGetPostsCommentList();
      } catch (e) {
        console.log("点赞失败", e);
        this.$layer.msg("点赞失败");
      }
    },
    async onFllowUser() {
      try {
        if(!this.is_login){
          this.$layer.msg('请先登录');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        await FollowUser({ follow_id: this.detail.user_id });
        this.$layer.msg("操作成功");
        this.onGetPosts();
      } catch (e) {
        console.log("关注失败", e);
        this.$layer.msg("关注失败");
      }
    },
    beforeLeaveHandler(el) {
      // 定义随机方向参数
      const dx = (Math.random() - 0.5) * 200; // 水平方向随机偏移（-100~+100）
      const dy = (Math.random() - 0.5) * 100; // 垂直方向随机偏移（-50~+50）
      const scale = Math.random() * 0.5 + 0.1; // 随机缩放比例（0.1~0.6）

      // 动态设置元素样式
      el.style.transition = "all 0.3s ease-out";
      el.style.transform = `translate(${dx}px, ${dy}px) scale(${scale})`;
      el.style.opacity = "0";
    },
    async onPostsCollect() {
      try {
        if(!this.is_login){
          this.$layer.msg('请先登录');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        if(this.postType == 1){
          await PostsCollect({ uuid: this.uuid });
        }else{
          await MatchPostsCollect({ uuid: this.uuid });
        }
        const msg = this.detail.is_collect ? "取消收藏成功" : "收藏成功";
        this.$layer.msg(msg);
        this.onGetPosts();
      } catch (e) {
        console.log("收藏失败", e);
        this.$layer.msg("收藏失败");
      }
    },
    async onPostsLike() {
      try {
        if(!this.is_login){
          this.$layer.msg('请先登录');
          this.show_login = true;
          //this.$router.push({name:"Login"});
          return;
        }
        if(this.postType == 1){
          await PostsLike({ uuid: this.uuid });
        }else{
          await MatchPostsLike({ uuid: this.uuid });
        }
        const msg = this.detail.is_zan ? "取消点赞成功" : "点赞成功";
        this.$layer.msg(msg);
        this.onGetPosts();
      } catch (e) {
        console.log("点赞失败", e);
        this.$layer.msg("点赞失败");
      }
    },
    onReplyClick(item) {
      console.log('item',item);
      // this.reply_comment.reply_name = item.frommember.nickname || item.frommember.username;
      // this.reply_comment.reply_content = item.content;
      this.$set(this.reply_comment,'reply_name',item.frommember.nickname || item.frommember.username);
      this.$set(this.reply_comment,'reply_content',item.content);
      this.select_post_uuid = this.uuid;
      this.select_quote_uuid = item.uuid;
      this.is_replying = true;
    },
    async onReplyPosts() {
      try {
        if (this.reply_status) {
          return;
        }
        const { uuid, comment_content, select_post_uuid, select_quote_uuid } =
          this;
        if (!comment_content) {
          return;
        }
        this.reply_status = true;
        const param = {};
        param.post_uuid = select_post_uuid || uuid;
        param.content = comment_content;
        param.quote_uuid = select_quote_uuid;
        if(this.postType == 1){
          await ReplyPosts(param);
        }else{
          await MatchReplyPosts(param)
        }
        this.onGetPostsCommentList();
        this.$layer.msg("评论成功");
        this.comment_content = "";
        this.select_post_uuid = "";
        this.select_quote_uuid = "";
        this.is_replying = false;
        this.reply_comment = {};
      } catch (e) {
        this.$layer.msg("评论失败");
        return;
      } finally {
        this.reply_status = false;
        this.onGetPosts()
      }
    },
    async onGetPostsCommentList() {
      const {postType} = this;
      switch(postType){
        case 1:{
          const { uuid } = this;
          const { data } = await GetPostsCommentList({ uuid });
          console.log("data", data);
          this.comment_list = data;
          break;
        }
        case 2:{
          const { uuid } = this;
          const { data } = await GetMatchPostsCommentList({ uuid });
          console.log("data", data);
          this.comment_list = data;
        }
      }
    },
    async onGetPosts() {
      try{
        const { uuid,postType } = this;
        let res = {};
        switch(postType){
          case 1:{
            const { data } = await GetPostsByUUID({ uuid });
            res = data;
            break;
          }
          case 2:{
            const { data } = await GetMatchPostDetail({ uuid });
            res = data;
            res.type = 1;
            break;
          }
        }
        this.swiperOptions.loopedSlides = res.image_list.length;
        this.detail = res;
      }catch(e){
        this.$layer.msg(e.msg)
        this.$emit('on-close');
      }
    },
    onShareClick(type) {
      console.log("type", type);
      const status = type == "cancel" ? false : true;
      this.is_share_click = status;
      console.log("aaa", this.is_share_click);
    },
    async onCopyLink() {
      if(this.postType == 1){
        let text = `${window.location.origin}/${this.uuid}`;
        if(this.is_login) {
          text += '/' + this.userInfo.code
        }
        await navigator.clipboard.writeText(text);
      }else{
        const text1 = `${window.location.href}/?post_uuid=${this.uuid}`;
        await navigator.clipboard.writeText(text1);
      }

      this.$layer.msg("复制成功");
      this.is_share_click = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.article-container {
  width: 100%;
  height:100%;
  position: fixed;
  // background: #f7f7f7;
  background:rgba(0,0,0,0.25);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  overflow-y: auto;
  font-family: 'MicrosoftYaHei';
  &::-webkit-scrollbar{
    display:none;
  }
  // overflow:hidden;
  transform-origin: center;
  animation: centerExpand 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94); /* 添加缓动曲线 */
  @keyframes centerExpand {
    0% {
      transform: scale(0.8) translateY(-10px); /* 初始状态缩小+上移 */
      opacity: 0;
    }
    100% {
      transform: scale(1) translateY(0); /* 完全显示 */
      opacity: 1;
    }
  }

  &.fade-leave-active {
    transition: all 0.3s ease-out;
  }

  .main {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    margin-top: 15px;
    padding: 0 80px;

    .return-btn {
      margin-top: 30px;
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 22px;
    }

    .content-container {
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      width: 1100px;
      max-height:860px;
      background: #ffffff;
      // border-top-left-radius: 20px;
      // padding: 30px 0 18px 25px;
      border-radius:20px;
      padding:15px 0 15px 15px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;

      .img-video {
        width: 620px;
        height: 830px;
        background: #f7f7f7;
        border-radius: 10px;
        overflow: hidden;
      }

      .desc-container {
        width: calc(1100px - 620px);
        display:flex;
        flex-direction:column;
        height:100%;
        margin-left:25px;
        margin-right:15px;

        .right-top {
          border-bottom: 1px solid #ececec;
          width: 100%;
          margin-top: 16px;
          // padding-left: 41px;
          padding-bottom: 20px;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;

          .nick-avatar-box {
            display: flex;
            justify-content: start;
            align-items: center;

            .avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              cursor:pointer;
              object-fit:cover;
            }

            .nick-box {
              margin-left: 10px;

              .nick {
                color: #1c1f23;
                font-size: 16px;
              }

              .job {
                color: #5c5c5c;
                font-size: 12px;
              }
            }
          }

          .btn-box {
            display: flex;
            justify-content: end;
            align-items: center;

            .like-box {
              margin: 0 4px;
              width: 40px;
              height: 40px;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid #e8e8e9;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              cursor: pointer;

              &:hover{
                background:#f4f6f6;
              }

              .like-icon {
                width: 18px;
                height: 18px;
              }

              .like-num {
                width: 100%;
                text-align: center;
                color: #5c5c5c;
                font-size: 11px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }

            .favorite-box {
              margin: 0 4px;
              width: 40px;
              height: 40px;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid #e8e8e9;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              cursor: pointer;
              &:hover{
                background:#f4f6f6;
              }
              .favorite-icon {
                width: 18px;
                height: 18px;
              }

              .favorite-num {
                width: 100%;
                text-align: center;
                color: #5c5c5c;
                font-size: 11px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }

            .pop-share {
              background: rgba(0, 0, 0, 0.8);
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;

              .link-icon {
                width: 18px;
                height: 18px;
                margin-right: 5px;
              }
            }

            .share-btn {
              margin: 0 8px;
              width: 40px;
              height: 40px;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid #e8e8e9;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              &:hover{
                background:#f4f6f6;
              }

              .share-icon {
                width: 14px;
                height: 15px;
              }
            }

            .follow-btn {
              background: #ff5967;
              color: #ffffff;
              border: none;
              border-radius: 10px;
              width: 76px;
              height: 40px;
            }
            .unfollow-btn {
              background: #ffffff;
              color: #000000;
              // border:none;
              border-radius: 10px;
              width: 76px;
              height: 40px;
            }
          }
        }

        .content-box {
          width: 100%;
          height:100%;
          max-height: 640px;
          flex:1;
          overflow-y:auto;
          transition:height 0.3s ease;
          border-bottom: 1px solid #ececec;
          &::-webkit-scrollbar{
            display:none;
          }

          .content-main {
            padding: 25px 0 0 0;
            width: 100%;

            .content-title {
              font-weight: bold;
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 20px;
              color:#000000;
            }

            .time-view-box {
              display: flex;
              align-items: center;
              justify-content:space-between;
              color: #5c5c5c;
              font-size: 14px;
              margin-top: 10px;
              width: 100%;
              .time-view-container{
                flex:1;
                display:flex;
                align-items:center;
                .time {
                  margin-right: 20px;
                  // flex:0 0 57%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .view-box {
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;

                  .view-icon {
                    width: 19px;
                    height: 19px;
                  }
                }
              }
              .more-box{
                display:flex;
                flex-direction:column;
                row-gap:10px;
                position:relative;
                .more-icon{
                  width:22px;
                  height:22px;
                }
                .report-post-btn{
                  width:103px;
                  height:40px;
                  display:flex;
                  justify-content:center;
                  align-items:center;
                  background:#ffffff;
                  color:#000000;
                  border-radius:10px;
                  box-shadow:0px 0px 6px 0px #e0e0e0;
                  position:absolute;
                  left:-350%;
                  right:0;
                  bottom:-200%;
                  z-index:100;
                  cursor:pointer;
                }
              }
            }

            .desc-content {
              color: #333333;
              font-size: 16px;
              margin-top: 25px;
              padding-bottom: 20px;
              &.content-border{
                border-bottom:1px solid #ececec;
              }
            }

            .product-box{
              width:100%;
              padding-bottom:20px;
              border-bottom:1px solid #ececec;
              cursor:pointer;
              .product-container{
                width:100%;
                background:#F7F7F7;
                border-radius:6px;
                padding:8px;
                display:flex;
                column-gap:9px;
                .product-cover{
                  width:36px;
                  height:48px;
                  border-radius:4px;
                }
                .product-info{
                  display:flex;
                  flex-direction:column;
                  row-gap:5px;
                  flex:1;
                  .product-name{
                    width:100%;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    font-size:14px;
                    color:#333333;
                  }
                  .price-tag-box{
                    display:flex;
                    align-items:center;
                    column-gap:8px;
                    .price{
                      font-weight:500;
                      color:#ff0f23;
                      font-size:14px;
                    }
                    .tag{
                      color:#999;
                      font-size:12px;
                    }
                  }
                }
              }
            }

            .comment-box {
              margin-top: 20px;
              width: 100%;

              .comment-title {
                color: #0f0f0f;
                font-size: 16px;

                .comment-count {
                  color: #808080;
                  font-size: 14px;
                }
              }

              .comment-main {
                margin-top: 20px;

                .comment-item-box {
                  display: flex;
                  justify-content: flex-start;
                  margin-bottom: 25px;
                  max-width: 100%;
                  overflow: hidden;
                  white-space: pre-wrap;

                  > div {
                    flex: 1;
                  }

                  .comment-avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-right: 10px;
                    object-fit:cover;
                  }

                  .comment-nick-box{
                    display:flex;
                    justify-content: space-between;
                    align-items:center;
                    .comment-nick {
                      width: 100%;
                      margin-right: 10px;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      color: #858585;
                      font-size: 14px;
                      display: flex;
                      align-items: center;
                      max-width: 200px;

                      .comment-nick-tag {
                        margin-left: 10px;
                        margin-right: 15px;
                        border-radius: 10px;
                        background: #f7f7f7;
                        font-size: 12px;
                        color: #858585;
                        padding: 5px;
                      }

                    }

                    .nick-more-menu{
                        width:23px;
                        height: 23px;
                        display:flex;
                        justify-content:center;
                        align-items:center;
                        position:relative;
                        img{
                          width:15px;
                          height:15px;
                        }
                        &:hover{
                          background:#f5f5f5;
                          border-radius:100%;
                        }
                        &.active{
                          background:#f5f5f5;
                          border-radius:100%;
                        }
                        .report-btn, .delete-btn{
                          width:103px;
                          height:40px;
                          display:flex;
                          justify-content:center;
                          align-items:center;
                          background:#ffffff;
                          color:#000000;
                          border-radius:10px;
                          box-shadow:0px 0px 6px 0px #e0e0e0;
                          position:absolute;
                          left:-350%;
                          right:0;
                          bottom:-200%;
                          cursor:pointer;
                        }
                    }
                  }

                  .comment-content {
                    width: 100%;
                    color: #1a1a1a;
                    font-size: 14px;
                  }

                  .comment-time {
                    margin-top: 5px;
                    color: #808080;
                    font-size: 12px;
                  }

                  .comment-like-count {
                    display: flex;
                    align-items: center;
                    margin-top: 10px;

                    .comment-like-count-item-left {
                      display: flex;
                      align-items: center;
                      margin-right: 20px;
                      cursor: pointer;
                    }

                    .comment-like-count-item-right {
                      display: flex;
                      align-items: center;
                      cursor: pointer;
                    }

                    .like-count-icon {
                      width: 18px;
                      height: 18px;
                      margin-right: 5px;
                      cursor: pointer;
                    }
                  }

                  .comment-child-box {
                    display: flex;
                    justify-content: start;
                    margin-top: 20px;

                    .nick-box {
                      flex: 1;
                      white-space: pre-wrap;
                      overflow: auto;
                      .nick-container {
                        display: flex;
                        align-items: center;
                        justify-content: start;
                        width: 100%;
                        .comment-nick-box{
                          display:flex;
                          justify-content: space-between;
                          align-items:center;
                          width:100%;

                          .nick-more-menu{
                            width:23px;
                            height: 23px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            position:relative;
                            img{
                              width:15px;
                              height:15px;
                            }
                            &:hover{
                              background:#f5f5f5;
                              border-radius:100%;
                            }
                            &.active{
                              background:#f5f5f5;
                              border-radius:100%;
                            }
                            .delete-btn{
                              width:103px;
                              height:40px;
                              display:flex;
                              justify-content:center;
                              align-items:center;
                              background:#ffffff;
                              color:#000000;
                              border-radius:10px;
                              box-shadow:0px 0px 6px 0px #e0e0e0;
                              position:absolute;
                              left:-350%;
                              right:0;
                              bottom:-200%;
                              cursor:pointer;
                            }
                        }
                          .comment-nick {
                            // width: 100%;
                            margin-right: 10px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            color: #858585;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            // flex:1;
                            max-width: 180px;

                            .comment-nick-tag {
                              margin-left: 10px;
                              border-radius: 10px;
                              background: #f7f7f7;
                              font-size: 12px;
                              color: #858585;
                              padding: 5px;
                            }
                          }
                          .comment-nick-tag {
                            margin-left: 10px;
                            border-radius: 10px;
                            background: #f7f7f7;
                            font-size: 12px;
                            color: #858585;
                            padding: 5px;
                          }
                        }
                      }
                    }

                    .comment-avatar {
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      margin-right: 10px;
                      object-fit:cover;
                    }

                    .comment-content {
                      width: 100%;
                      color: #1a1a1a;
                      font-size: 14px;
                    }

                    .comment-time {
                      margin-top: 5px;
                      color: #808080;
                      font-size: 12px;
                    }

                    .comment-like-count-box {
                      display: flex;
                      align-items: center;
                      margin-top: 10px;

                      .comment-like-count-item-left {
                        display: flex;
                        align-items: center;
                        margin-right: 20px;
                        cursor: pointer;
                      }

                      .comment-like-count-item-right {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                      }

                      .comment-like-count-icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 5px;
                      }
                    }
                  }

                  .more-comment {
                    color: #13386c;
                    font-size: 14px;
                    margin-top: 10px;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }

        .reply-box{
          margin-top:20px;
          margin-left:21px;
          font-size:14px;
          .reply-to{
            color:#858585;
          }
          .reply-content{
            color:#333333;
          }
        }

        .comment-form {
          padding: 15px 20px 10px 0px;

          .comment-input-box {
            height: 45px;
            background: #f7f7f7;
            border-radius: 23px 23px 23px 23px;
            display: flex;
            align-items: center;

            .un-login{
              color:#999999;
              font-size:14px;
              margin-left:20px;
            }

            .comment-input {
              border: none;
              outline: none;
              background: transparent;
              margin-left: 20px;
              width: 100%;
              padding-right: 20px;
            }
          }

          .function-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            // position:relative;

            .icon-emoji {
              width: 26px;
              height: 26px;
              margin-left: 20px;
              background-image: url(../assets/images/icon-emoji-list-popup.png);
              background-repeat: no-repeat;
              background-size: cover;
              border: none;
            }

            Button {
              background: transparent;
            }

            .emoji-invoker {
              position: absolute;
              top: 0.5rem;
              right: 0.5rem;
              width: 1.5rem;
              height: 1.5rem;
              border-radius: 50%;
              cursor: pointer;
              transition: all 0.2s;
              padding: 0;
              background: transparent;
              border: 0;
            }
            .emoji-invoker:hover {
              transform: scale(1.1);
            }
            // .emoji-invoker > svg {
            //   fill: #b1c6d0;
            // }

            .emoji-picker {
              position: absolute;
              z-index: 1;
              font-family: Montserrat;
              border: 1px solid #ccc;
              width: 30rem;
              height: 20rem;
              overflow: scroll;
              padding: 1rem;
              box-sizing: border-box;
              border-radius: 0.5rem;
              background: #fff;
              box-shadow: 1px 1px 8px #c7dbe6;
              top: 430px !important;
              left: 1000px !important;
            }
            .emoji-picker__search {
              display: none;
            }
            .emoji-picker__search > input {
              flex: 1;
              border-radius: 10rem;
              border: 1px solid #ccc;
              padding: 0.5rem 1rem;
              outline: none;
            }
            .emoji-picker h5 {
              margin-bottom: 0;
              color: #b1b1b1;
              text-transform: uppercase;
              font-size: 0.8rem;
              cursor: default;
            }
            .emoji-picker .emojis {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            }
            .emoji-picker .emojis:after {
              content: "";
              flex: auto;
            }
            .emoji-picker .emojis span {
              padding: 0.2rem;
              cursor: pointer;
              border-radius: 5px;
            }
            .emoji-picker .emojis span:hover {
              background: #ececec;
              cursor: pointer;
            }

            .form-btn-box{
              .cancel-btn{
                border-radius:10px;
                margin-right:10px;
                border:1px solid #ebebeb;
              }
              .submit-btn {
                background: #ff5967;
                border: none;
                color: #ffffff;
                border-radius: 10px;
              }
            }
          }
        }
      }
    }
  }
}

::v-deep .ivu-poptip-arrow:after {
  border-bottom-color: rgba(0, 0, 0, 0.9) !important;
}

::v-deep .ivu-poptip-inner {
  background-color: rgba(0, 0, 0, 0.9) !important;
  border-radius: 15px;
}

/**swiper样式调整开始 */
.swiper-container {
  position: relative;
  /* 确保按钮定位参考容器 */
  width: 100%;
  height: 830px;
  overflow: hidden;
  border-radius: 10px;
  /* 允许前后幻灯片溢出显示 */
}

.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* 幻灯片宽度占容器的 80% */
  // background: #000000;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.swiper-container::before {
  left: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
}

.swiper-container::after {
  right: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
}

/* 调整导航按钮位置到中间 */
.custom-prev-btn,
.custom-next-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  font-size: 30px;
  cursor: pointer;
  z-index: 10;
}

.custom-prev-btn {
  left: 2%;
  // transform: translateX(-50%) translateY(-50%);
}

.custom-next-btn {
  right: 2%;
  // transform: translateX(-50%) translateY(-50%);
}

.swiper-img {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  object-fit: contain;
  // background:#000000;
}

.swiper-bottom-bg {
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 10;
}

::v-deep .swiper-pagination {
  text-align: center;
  margin-top: 20px;
  // background-image: url(../assets/images/bg-swiper-pagination.png);
  // background-size: cover;
  // background-repeat: no-repeat;
  padding-bottom: 10px;
  margin-bottom: -10px;
}

/* 自定义圆点样式 */
::v-deep .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: rgba(230, 230, 230, 0.8);
  opacity: 1; // 取消默认透明度
  border-radius: 50%;
  margin: 0 5px;
}

/* 激活状态样式 */
::v-deep .my-swiper-pagination-active {
  background: #ffffff;
  box-shadow:0px 0px 3px 0px #e0e0e0;
}

/**Swiper样式调整结束 */
@media (min-width: 1280px) and (max-width: 1679px) {
  .article-container {
    .main {
      margin-top: 20px;
      padding: 0 72px;

      .return-btn {
        margin-top: 20px;
        height: 19.8px;
      }

      .content-container {
        width: 990px;
        border-top-left-radius: 18px;
        padding: 13.5px 0 13.5px 13.5px;

        .img-video {
          width: 558px;
          height: 747px;
          border-radius: 9px;
        }

        .desc-container {
          width: calc(990px - 558px);
          margin-left:22.5px;

          .right-top {
            margin-top: 14.4px;
            // padding-left: 36.9px;
            padding-bottom: 18px;
            padding-right: 18px;

            .nick-avatar-box {
              .avatar {
                width: 36px;
                height: 36px;
              }

              .nick-box {
                margin-left: 9px;

                .nick {
                  font-size: 14px;
                }

                .job {
                  font-size: 10px;
                }
              }
            }

            .btn-box {
              .like-box {
                margin: 0 3.6px;
                width: 36px;
                height: 36px;
                border-radius: 9px;
                .like-icon {
                  width: 16.2px;
                  height: 16.2px;
                }

                .like-num {
                  font-size: 9px;
                }
              }

              .favorite-box {
                margin: 0 3.6px;
                width: 36px;
                height: 36px;
                border-radius: 9px;

                .favorite-icon {
                  width: 16.2px;
                  height: 16.2px;
                }

                .favorite-num {
                  font-size: 9px;
                }
              }

              .pop-share {
                .link-icon {
                  width: 16.2px;
                  height: 16.2px;
                  margin-right: 4.5px;
                }
              }

              .share-btn {
                margin: 0 7.2px;
                width: 36px;
                height: 36px;
                border-radius: 9px;

                .share-icon {
                  width: 12.6px;
                  height: 13.5px;
                }
              }

              .follow-btn {
                border-radius: 9px;
                width: 68.4px;
                height: 36px;
              }
              .unfollow-btn {
                border-radius: 9px;
                width: 68.4px;
                height: 36px;
              }
            }
          }

          .content-box {
            max-height: 578.7px;
            .content-main {
              // padding: 27px 31.5px 0 31.5px;
              padding:22.5px 0 0 0;
              .content-title {
                font-size: 16px;
              }

              .time-view-box {
                font-size: 12px;
                margin-top: 9px;

                .time {
                  margin-right: 18px;
                }

                .view-box {
                  .view-icon {
                    width: 17.1px;
                    height: 17.1px;
                  }
                }
              }

              .desc-content {
                font-size: 14px;
                margin-top: 27px;
                padding-bottom: 18px;
              }

              .comment-box {
                margin-top: 18px;

                .comment-title {
                  font-size: 14px;

                  .comment-count {
                    font-size: 12px;
                  }
                }

                .comment-main {
                  margin-top: 18px;

                  .comment-item-box {
                    margin-bottom: 22.5px;
                    .comment-avatar {
                      width: 36px;
                      height: 36px;
                      margin-right: 9px;
                    }

                    .comment-nick {
                      margin-right: 9px;
                      font-size: 14px;
                      max-width: 180px;

                      .comment-nick-tag {
                        margin-left: 9px;
                        margin-right: 13.5px;
                        border-radius: 9px;
                        font-size: 10px;
                        padding: 4.5px;
                      }
                    }

                    .comment-content {
                      font-size: 14px;
                    }

                    .comment-time {
                      margin-top: 4.5px;
                      font-size: 10px;
                    }

                    .comment-like-count {
                      margin-top: 9px;

                      .comment-like-count-item-left {
                        margin-right: 18px;
                      }

                      .like-count-icon {
                        width: 16.2px;
                        height: 16.2px;
                        margin-right: 4.5px;
                      }
                    }

                    .comment-child-box {
                      margin-top: 18px;

                      .nick-box {
                        .nick-container {
                          .comment-nick {
                            margin-right: 9px;
                            font-size: 14px;
                            max-width: 162px;

                            .comment-nick-tag {
                              margin-left: 9px;
                              border-radius: 9px;
                              font-size: 10px;
                              padding: 4.5px;
                            }
                          }
                          .comment-nick-tag {
                            margin-left: 9px;
                            border-radius: 9px;
                            font-size: 10px;
                            padding: 4.5px;
                          }
                        }
                      }

                      .comment-avatar {
                        width: 36px;
                        height: 36px;
                        margin-right: 9px;
                      }

                      .comment-content {
                        font-size: 14px;
                      }

                      .comment-time {
                        margin-top: 4.5px;
                        font-size: 10px;
                      }

                      .comment-like-count-box {
                        margin-top: 9px;

                        .comment-like-count-item-left {
                          margin-right: 18px;
                        }

                        .comment-like-count-icon {
                          width: 16.2px;
                          height: 16.2px;
                          margin-right: 4.5px;
                        }
                      }
                    }

                    .more-comment {
                      font-size: 12px;
                      margin-top: 9px;
                    }
                  }
                }
              }
            }
          }

          .reply-box{
            margin-top:18px;
            margin-left:18.9px;
            font-size:12px;
          }

          .comment-form {
            padding: 18px 18px 18px 0;

            .comment-input-box {
              height: 40.5px;
              border-radius: 20.7px;

              .comment-input {
                margin-left: 18px;
                padding-right: 18px;
              }
            }

            .function-box {
              margin-top: 9px;

              .icon-emoji {
                width: 26px;
                height: 26px;
                margin-left: 20px;
                background-image: url(../assets/images/icon-emoji-list-popup.png);
                background-repeat: no-repeat;
                background-size: cover;
                border: none;
                &:focus{
                    border:none !important;
                }
              }

              Button {
                background: transparent;
                border:none;
              }

              .emoji-picker {
                position: absolute;
                z-index: 1;
                font-family: Montserrat;
                border: 1px solid #ccc;
                width: 30rem;
                height: 20rem;
                overflow: scroll;
                padding: 1rem;
                box-sizing: border-box;
                border-radius: 0.5rem;
                background: #fff;
                box-shadow: 1px 1px 8px #c7dbe6;
                top: 340px !important;
                left: 730px !important;
              }
              .form-btn-box{
                .cancel-btn{
                  border-radius:10px;
                  margin-right:10px;
                }
                .submit-btn {
                  background: #ff5967;
                  border: none;
                  color: #ffffff;
                  border-radius: 10px;
                }
              }
            }
          }
        }
      }
    }
  }

  ::v-deep .ivu-poptip-arrow:after {
    border-bottom-color: rgba(0, 0, 0, 0.9) !important;
  }

  ::v-deep .ivu-poptip-inner {
    background-color: rgba(0, 0, 0, 0.9) !important;
    border-radius: 15px;
  }

  /**swiper样式调整开始 */
  .swiper-container {
    position: relative;
    /* 确保按钮定位参考容器 */
    width: 100%;
    height: 747px;
    overflow: hidden;
    border-radius: 10px;
    /* 允许前后幻灯片溢出显示 */
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* 幻灯片宽度占容器的 80% */
    // background: #000000;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .swiper-container::before {
    left: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
  }

  .swiper-container::after {
    right: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
  }

  /* 调整导航按钮位置到中间 */
  .custom-prev-btn,
  .custom-next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    z-index: 10;
  }

  .custom-prev-btn {
    left: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .custom-next-btn {
    right: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .swiper-img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .swiper-bottom-bg {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
  }

  ::v-deep .swiper-pagination {
    text-align: center;
    margin-top: 20px;
    // background-image: url(../assets/images/bg-swiper-pagination.png);
    background-size: cover;
    background-repeat: no-repeat;
    padding-bottom: 10px;
    margin-bottom: -10px;
  }

  /* 自定义圆点样式 */
  ::v-deep .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: rgba(0, 0, 0, 0.6);
    opacity: 1; // 取消默认透明度
    border-radius: 50%;
    margin: 0 5px;
  }

  /* 激活状态样式 */
  ::v-deep .my-swiper-pagination-active {
    background: #ffffff;
  }
}

@media (max-width: 1279px) {
  .article-container {
    .main {
      margin-top: 24px;
      padding: 0 64px;

      .return-btn {
        margin-top: 24px;
        height: 17.6px;
      }

      .content-container {
        width: 880px;
        padding: 12px 0 12px 12px;

        .img-video {
          width: 496px;
          height: 664px;
        }

        .desc-container {
          width: calc(880px - 496px);
          margin-left:20px;

          .right-top {
            margin-top: 14.4px;
            // padding-left: 32.8px;
            padding-bottom: 16px;
            padding-right: 16px;

            .nick-avatar-box {
              .avatar {
                width: 32px;
                height: 32px;
              }
              .nick-box {
                margin-left: 8px;
                .nick {
                  font-size: 14px;
                }

                .job {
                  font-size: 10px;
                }
              }
            }

            .btn-box {
              .like-box {
                margin: 0 3.2px;
                width: 32px;
                height: 32px;
                border-radius: 8px;

                .like-icon {
                  width: 14.4px;
                  height: 14.4px;
                }

                .like-num {
                  font-size: 9px;
                }
              }

              .favorite-box {
                margin: 0 3.2px;
                width: 32px;
                height: 32px;
                border-radius: 8px;

                .favorite-icon {
                  width: 14.4px;
                  height: 14.4px;
                }

                .favorite-num {
                  font-size: 9px;
                }
              }

              .pop-share {
                .link-icon {
                  width: 14.4px;
                  height: 14.4px;
                  margin-right: 4px;
                }
              }

              .share-btn {
                margin: 0 6.4px;
                width: 32px;
                height: 32px;
                border-radius: 8px;

                .share-icon {
                  width: 11.2px;
                  height: 12px;
                }
              }

              .follow-btn {
                border-radius: 8px;
                width: 60.8px;
                height: 32px;
              }
              .unfollow-btn {
                border-radius: 8px;
                width: 60.8px;
                height: 32px;
              }
            }
          }

          .content-box {
            width: 100%;
            max-height: 514.4px;
            .content-main {
              padding: 20px 0 0 0;
              .content-title {
                font-size: 16px;
              }

              .time-view-box {
                font-size: 12px;
                margin-top: 8px;

                .time {
                  margin-right: 16px;
                }

                .view-box {
                  .view-icon {
                    width: 15.2px;
                    height: 15.2px;
                  }
                }
              }

              .desc-content {
                font-size: 14px;
                margin-top: 24px;
                padding-bottom: 16px;
              }

              .comment-box {
                margin-top: 16px;
                width: 100%;

                .comment-title {
                  font-size: 14px;

                  .comment-count {
                    font-size: 12px;
                  }
                }

                .comment-main {
                  margin-top: 16px;

                  .comment-item-box {
                    margin-bottom: 20px;
                    .comment-avatar {
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      margin-right: 8px;
                    }

                    .comment-nick {
                      margin-right: 8px;
                      font-size: 14px;
                      max-width: 160px;

                      .comment-nick-tag {
                        margin-left: 8px;
                        margin-right: 12px;
                        border-radius: 8px;
                        font-size: 10px;
                        padding: 4px;
                      }
                    }

                    .comment-content {
                      font-size: 14px;
                    }

                    .comment-time {
                      margin-top: 4px;
                      font-size: 10px;
                    }

                    .comment-like-count {
                      margin-top: 8px;

                      .comment-like-count-item-left {
                        margin-right: 16px;
                      }

                      .like-count-icon {
                        width: 14.4px;
                        height: 14.4px;
                        margin-right: 4px;
                      }
                    }

                    .comment-child-box {
                      margin-top: 16px;

                      .nick-box {
                        .nick-container {
                          width: 100%;
                          .comment-nick {
                            margin-right: 8px;
                            font-size: 14px;
                            max-width: 144px;

                            .comment-nick-tag {
                              margin-left: 8px;
                              border-radius: 8px;
                              font-size: 10px;
                              padding: 4px;
                            }
                          }
                          .comment-nick-tag {
                            margin-left: 8px;
                            border-radius: 8px;
                            font-size: 10px;
                            padding: 4px;
                          }
                        }
                      }

                      .comment-avatar {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        margin-right: 8px;
                      }

                      .comment-content {
                        font-size: 14px;
                      }

                      .comment-time {
                        margin-top: 4px;
                        font-size: 10px;
                      }

                      .comment-like-count-box {
                        margin-top: 8px;

                        .comment-like-count-item-left {
                          margin-right: 16px;
                        }

                        .comment-like-count-icon {
                          width: 14.4px;
                          height: 14.4px;
                          margin-right: 4px;
                        }
                      }
                    }

                    .more-comment {
                      font-size: 12px;
                      margin-top: 8px;
                    }
                  }
                }
              }
            }
          }

          .reply-box{
            margin-top:16px;
            margin-left:16.8px;
            font-size:12px;
          }
          .comment-form {
            padding: 16px 16px 16px 0;

            .comment-input-box {
              height: 36px;
              border-radius: 18.4;

              .comment-input {
                margin-left: 16px;
                padding-right: 16px;
              }
            }

            .function-box {
              margin-top: 8px;
              .icon-emoji {
                width: 20.8px;
                height: 20.8px;
                margin-left: 16px;
              }

              .emoji-picker {
                top: 280px !important;
                left: 624px !important;
              }

              .submit-btn {
                border-radius: 8px;
              }
            }
          }
        }
      }
    }
  }

  ::v-deep .ivu-poptip-arrow:after {
    border-bottom-color: rgba(0, 0, 0, 0.9) !important;
  }

  ::v-deep .ivu-poptip-inner {
    background-color: rgba(0, 0, 0, 0.9) !important;
    border-radius: 15px;
  }

  /**swiper样式调整开始 */
  .swiper-container {
    /* 确保按钮定位参考容器 */
    height: 664px;
    border-radius: 8px;
    /* 允许前后幻灯片溢出显示 */
  }

  /* 调整导航按钮位置到中间 */
  .custom-prev-btn,
  .custom-next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-70%);
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    z-index: 10;
  }

  .custom-prev-btn {
    left: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .custom-next-btn {
    right: 2%;
    // transform: translateX(-50%) translateY(-50%);
  }

  .swiper-img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .swiper-bottom-bg {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
  }

  ::v-deep .swiper-pagination {
    text-align: center;
    margin-top: 20px;
    // background-image: url(../assets/images/bg-swiper-pagination.png);
    background-size: cover;
    background-repeat: no-repeat;
    padding-bottom: 10px;
    margin-bottom: -10px;
  }

  /* 自定义圆点样式 */
  ::v-deep .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: rgba(0, 0, 0, 0.6);
    opacity: 1; // 取消默认透明度
    border-radius: 50%;
    margin: 0 5px;
  }

  /* 激活状态样式 */
  ::v-deep .my-swiper-pagination-active {
    background: #ffffff;
  }

  /**Swiper样式调整结束 */
}

::v-deep .popup-modal .popup-content{
  padding:0;
}
.popup{
  width:100%;
  background:#ffffff;
  border-radius:15px;
  .title{
    color:#333333;
    font-size:16px;
    font-weight:bold;
    padding-top:17px;
    text-align:center;
    padding-bottom:17px;
    border-bottom:1px solid #e0e0e0;
  }
  .report-list{
    margin-top:17px;
    width:100%;
    height:100%;
    overflow-y:scroll;
    &::-webkit-scrollbar{
      display:none;
    }
    display:flex;
    flex-direction:column;
    row-gap:14px;
    padding:0 12px;
    .report-list-item{
      width:100%;
      display:flex;
      flex-direction:column;
      padding:0 12px;
      cursor:pointer;
      &:hover, .item-active{
        background:#f7f7f7;
      }
      &.item-active{
        padding-top:15px;
        padding-bottom:15px;
      }
      .report-list-item-selection{
        display:flex;
        align-items:center;
        justify-content:space-between;
        .label{
          color:#666666;
          font-size:16px;
          &.label-active{
            color:#292929;
            font-weight:bold;
          }
        }
        .value{
          width:20px;
          height:20px;
          border:2px solid #ebebeb;
          border-radius:50%;
          &.value-active{
            background:#fd4c5b;
            color:#ffffff;
            display:flex;
            align-items:center;
            justify-content:center;
          }
        }
      }
      .report-list-item-description{
        color:#8f8f8f;
        font-size:14px;
      }
    }
  }

  .report-confirm{
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    .report-attention{
      width:30px;
      height:30px;
      margin-top:25px;
    }
    .report-reason{
      color:#333333;
      font-size:18px;
      font-weight:bold;
      margin-top:15px;
    }
    .report-reason-description{
      color:#8f8f8f;
      font-size:14px;
      margin-top:22px;
      padding-bottom:27px;
      border-bottom:1px solid #e0e0e0;
      margin-bottom:30px;
      width:90%;
    }
    .report-form{
      width:90%;
      .report-label-container{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:space-between;
        .report-content-count, .report-label{
          color:#8f8f8f;
          font-size:14px;
        }
      }
      .report-description{
        background:#f7f7f7;
        border-radius:10px;
        margin-top:10px;
        margin-bottom:20px;
        width:100%;
        height:96px;
        textarea{
          width:100%;
          height:100%;
          padding:15px 10px;
          border:none;
          outline:none;
          background:transparent;
          resize:none;
        }
      }
      .image-list{
        width:100%;
        display:flex;
        align-items:center;
        column-gap:4px;
        margin-top:10px;
        .image-item{
          width:90px;
          height:90px;
          border-radius:10px;
          border:1px solid #ebebeb;
          position:relative;
          overflow:hidden;
          img{
            width:100%;
            height:100%;
            border-radius:10px;
          }
          .remove-ico{
            width:18px;
            height:18px;
            position:absolute;
            top:4px;
            right:5px;
          }
        }
        .upload-btn{
          width:90px;
          height:90px;
          // border:1px solid #ebebeb;
          // border-radius:10px;
          display:flex;
          align-items:center;
          justify-content:center;
          flex-direction:column;
          .upload-ico{
            width:28px;
            height:28px;
          }
          .btn-text{
            color:#8f8f8f;
            font-size:12px;
            cursor:pointer;
          }
        }
      }
    }
  }
  .pop-bottom{
    width:100%;
    border-top:1px solid #e0e0e0;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-top:14px;
    Button{
      background:#fd4c5b;
      color:#ffffff;
      border-radius:10px;
      margin:15px 0;
      width:92px;
      height:40px;
    }
  }
  .report-result{
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    .success-icon{
      width:60px;
      height:60px;
      margin-top:55px;
      margin-bottom:30px;
    }
    .success-title{
      color:#333333;
      font-size:32px;
      font-weight:bold;
      margin-bottom:24px;
    }
    .success-tips{
      color:#8f8f8f;
      font-size:16px;
      margin-bottom:46px;
    }
    .report-introduction{
      width:80%;
      background:#f8fafc;
      border-radius:10px;
      margin-bottom:80px;
      .intro-container{
        padding:20px;
        display:flex;
        flex-direction:column;
        row-gap:18px;
        .intro-title{
          display:flex;
          column-gap:10px;
          align-items:center;
          color:#333333;
          font-size:16px;
          img{
            width:17px;
            height:17px;
          }
        }
      }
    }
    .report-introduction-btns{
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      column-gap:20px;
      margin-bottom:68px;
      Button{
        width:161px;
        height:40px;
        border-radius:10px;
        background:#ffffff;
        border:1px solid #cccccc;
        &:last-child{
          background:#fa3d5c;
          color:#ffffff;
        }
      }
    }
  }
}
</style>
